<template>
  <AcaSchoolPageSkeleton
    v-if="props.loading"
    show-map-section />

  <template v-else-if="props.schoolPrograms">
    <!-- ── HERO BANNER avec IMAGE + LOGO ─────────────────────────────────────────────── -->
    <PrepeersHeroCover
      :src="props.schoolPrograms?.schoolprograms.coverPict"
      alt="Écoles PrePeers">
      <div class="hero-banner__logo">
        <PrepeersEntityLogo
          :logo-pict="props.schoolPrograms?.schoolprograms.logoPict"
          :entity-name="props.schoolPrograms?.schoolprograms.name ?? ''"
          :alt="`${props.schoolPrograms?.schoolprograms.name ?? 'École'} logo`" />
      </div>
    </PrepeersHeroCover>

    <PrepeersBreadcrumb
      auto
      section="ecoles"
      :current-label="props.schoolPrograms?.schoolprograms.h1" />

    <!-- ── HERO + H1 ─────────────────────────────────────────────── -->
    <section class="hero-section">
      <div class="container">
        <h1
          class="hero-section__h1"
          v-html="props.schoolPrograms?.schoolprograms.h1"></h1>
        <div class="hero-section__line" />
        <div
          v-if="props.schoolPrograms?.parsedSchoolTypeBlock"
          class="hero-section__subcontainer">
          <h2
            class="hero-section__title"
            v-html="props.schoolPrograms?.parsedSchoolTypeBlock.Title"></h2>
          <div
            v-if="filterSeoLinksWithLabel(props.schoolPrograms?.parsedSchoolTypeBlock.Links).length"
            class="hero-section__nav">
            <NuxtLink
              v-for="sl in filterSeoLinksWithLabel(
                props.schoolPrograms?.parsedSchoolTypeBlock.Links,
              )"
              :key="sl.Url"
              :to="localePath(sl.Url)"
              class="level-nav__link"
              >{{ sl.Text }}</NuxtLink
            >
          </div>
        </div>
        <div
          class="hero-section__intro"
          v-html="formatSeoIntro(props.schoolPrograms?.schoolprograms.introduction ?? '')" />
        <div class="hero-section__line" />
      </div>
    </section>

    <!-- ── LIENS PAGE PAYS ─────────────────────────────────────────────── -->
    <section
      v-if="props.schoolPrograms?.parsedCountriesBlock"
      class="level-nav-section">
      <div class="container">
        <h2 class="level-nav__title">{{ props.schoolPrograms?.parsedCountriesBlock.Title }}</h2>
        <div class="level-nav__list">
          <NuxtLink
            v-for="sl in props.schoolPrograms?.parsedCountriesBlock.Links"
            :key="sl.Url"
            :to="localePath(sl.Url)"
            class="level-nav__link"
            >{{ sl.Text }}</NuxtLink
          >
        </div>
      </div>
    </section>

    <!-- ──  MAP ─────────────────────────────────────────────── -->
    <AcaProgramsMapAndCards :programs="props.schoolPrograms?.parsedAddressesBlock ?? null" />
  </template>
</template>

<script setup lang="ts">
import AcaSchoolPageSkeleton from '~/components/aca/AcaSchoolPageSkeleton.vue'
import PrepeersEntityLogo from '~/components/core/PrepeersEntityLogo.vue'
import PrepeersHeroCover from '~/components/core/PrepeersHeroCover.vue'
import PrepeersBreadcrumb from '~/components/navigation/PrepeersBreadcrumb.vue'
import type { SchoolProgramsResponse } from '~/types/school'
import { filterSeoLinksWithLabel, formatSeoIntro } from '~/utils/helpers'

interface SchoolProgramsProps {
  schoolPrograms: SchoolProgramsResponse | null
  loading?: boolean
  isLoggedIn: boolean
}

const props = withDefaults(defineProps<SchoolProgramsProps>(), {
  loading: false,
})

const localePath = useLocalePath()
useI18n()
</script>
